import { useGetSignedBeaconIdentityV1GetQuery } from "@/store/baseClientApi";
import { Beacon } from "@/utils/beacon";
import { useEffect } from "react";

export const useIdentifyBeacon = () => {
  const { data } = useGetSignedBeaconIdentityV1GetQuery();

  useEffect(() => {
    if (data !== undefined) {
      Beacon("identify", {
        email: data.user_email ?? "",
        name: data.user_name,
        jobTitle: data.role_name ?? undefined,
        "organisation-id": Number(data.org_id),
        "organisation-name": data.org_name,
        signature: data.signed_hash
      });
    }
  }, [data]);

  return <></>;
};
